import {
  AlertType,
  CompanyBidApprovalType,
  CompanyDetectionPriceList
} from '@authority-labs/enums';
import { BaseDto } from './base.dto';
import { CompanyDirectory } from './company-directory.dto';
import { CompanyNote } from './company-note.dto';
import { CompanyStatus } from './company-status.dto';
import { Contact } from './contact.dto';

export class Company extends BaseDto {
  name?: string;
  address?: string;
  companyNumber?: string;
  icountNumber?: string;
  paymentTerms?: string;
  companyType?: string;
  detectionPriceList?: CompanyDetectionPriceList;
  bidApprovalType?: CompanyBidApprovalType;
  status?: CompanyStatus;
  contacts?: Contact[];
  notes?: CompanyNote[];
  files?: CompanyDirectory;
  sharePoint?: CompanyDirectory;

  isStatusDanger?() {
    return this.status?.type === AlertType.Danger;
  }

  isStatusWarning?() {
    return this.status?.type === AlertType.Warning;
  }
}
